import Vue from "vue";

const config = {
  site: "",
  signKey: ""
};
export default {
  /** 路由跳转
   *  @param {object} ctx 上下文
   *  @param {string} url 路由地址
   *  @param {object} ps 传递参数
   */
  toUrl(ctx, url, ps) {
    ctx.$router.push({ path: url, query: ps });
  },

  /** 新增&&修改本地缓存
   *  @param {string} id 唯一id
   *  @param {string} key 标示
   *  @param {string} value 新增&修改的值
   */
  saveLocal(key, value, isStorage) {
    key = config.signKey + key;
    value = this.filterNull(value);
    if (isStorage) {
      if (typeof value == "object") {
        window.localStorage[key] = JSON.stringify(value || {});
      } else {
        window.localStorage[key] = value;
      }
      //console.log(window.localStorage[key]);
    } else {
      let expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + 3600 * 3600 * 60 * 1000);
      // if (!value) {
      //   expireDate.setDate(expireDate.getDate() - 2)
      // }
      if (typeof value == "object") {
        document.cookie =
          key + "=" + JSON.stringify(value) + (";expires=" + expireDate);
      } else {
        document.cookie = key + "=" + value + (";expires=" + expireDate);
      }
    }

    // window.localStorage[key] = encodeURIComponent(JSON.stringify(value));
  },
  /** 查询本地缓存
   *  @param {string} id 唯一id
   *  @param {string} key 标示
   *  @param {string} def 如果查询不到显示的值
   */
  loadLocal(key, isStorage) {
    key = config.signKey + key;
    let value;
    if (isStorage) {
      value = window.localStorage[key] ? window.localStorage[key] : undefined;
      return value;
    } else {
      if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(key + "=");
        if (c_start != -1) {
          c_start = c_start + key.length + 1;
          let c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          value = JSON.parse(document.cookie.substring(c_start, c_end));
          return value;
        }
      }
    }

    // if (!window.localStorage[key]) {
    //   return def;
    // }
    // let ret = decodeURIComponent(window.localStorage[key]);
    // return ret != 'undefined' ? JSON.parse(ret) : def;
  },
  //读取cookie
  loadLocal2(key) {
    let keys = config.signKey + key;
    var arr,
      reg = new RegExp("(^| )" + keys + "=([^;]*)(;|$)");
    if (arr == document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },

  /** 格式化时间
   *  @param {string} date 需要格式化的时间
   *  @param {string} fmt 想要格式化的格式
   */
  /** 格式化时间，返回年，月，日
   *  @param {string } date 需要格式化的时间
   */
  objectDate(date) {
    if (date && typeof date === "string") {
      date = new Date(date);
      let o = {
        Y: date.getFullYear(),
        M: date.getMonth() + 1,
        D: date.getDate()
      };
      return o;
    }
    return date;
  },
  /** 格式化时间，返回时间差，年，月，日
   * @param {string} date 开始日期字符串
   * @param {string} endDate 结束日期字符串
   * @param {Number} i 第几类 0秒，1分钟，2小时，3天，4月，5年
   * @param {Boolean} isUnit 是否输出单位
   * */
  time2Diff(date, endDate, i, isUnit) {
    // 开始时间
    let startTime = {};
    if (date) startTime = new Date(date);
    else {
      startTime = new Date();
    }
    // 结束时间
    let endTime = {};
    if (endDate) {
      endTime = new Date(endDate);
    } else {
      endTime = new Date();
    }
    startTime.setHours(0);
    startTime.setMinutes(0);
    startTime.setSeconds(0);
    endTime.setHours(0);
    endTime.setMinutes(0);
    endTime.setSeconds(0);
    // 时间差的毫秒数
    let timeDifferent = endTime.getTime() - startTime.getTime();

    function filter(value, index) {
      if (i == undefined) {
        return compare(value, index)
          ? filter(compare(value, index), index + 1)
          : describe(value, index);
      } else {
        return compare(value, index) && index < i
          ? filter(compare(value, index), index + 1)
          : describe(value, index);
      }
    }

    function compare(value, index) {
      switch (index) {
        case 0:
          return (value / 60).toFixed(0);
        case 1:
          return (value / 60).toFixed(0);
        case 2:
          return (value / 24).toFixed(0);
        case 3:
          return (value / 30).toFixed(0);
        case 4:
          return (value / 12).toFixed(0);
      }
    }

    function describe(value, index) {
      switch (index) {
        case 0:
          return isUnit ? value + "秒前" : Number(value);
        case 1:
          return isUnit ? value + "分钟前" : Number(value);
        case 2:
          return isUnit ? value + "小时前" : Number(value);
        case 3:
          return isUnit ? value + "天前" : Number(value);
        case 4:
          return isUnit ? value + "月前" : Number(value);
        case 5:
          return isUnit ? value + "年前" : Number(value);
      }
    }

    return filter(timeDifferent / 1000, 0);
  },
  /** 格式化时间，返回该日期是星期几
   * @param {string} date 需要格式化的时间
   * */
  timeWeek(date) {
    date = new Date(date);
    if (date.getDay() == 0) return "日";
    if (date.getDay() == 1) return "一";
    if (date.getDay() == 2) return "二";
    if (date.getDay() == 3) return "三";
    if (date.getDay() == 4) return "四";
    if (date.getDay() == 5) return "五";
    if (date.getDay() == 6) return "六";
  },
  /** 格式化时间，返回该日期是星期几
   * @param {Number} count 天数
   * @param {String} placeholder 占位符
   * */
  showAfterDate(count, date, placeholder) {
    let dd = {};
    if (date) {
      dd = new Date(date);
    } else {
      dd = new Date();
    }
    dd.setDate(dd.getDate() + count); //获取count天后的日期
    let y = dd.getFullYear();
    let m =
      dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
    let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
    return y + (placeholder || "-") + m + (placeholder || "-") + d;
  },

  /** 提示
   *  @param {string} msg 提示消息内容
   */
  toast(msg) {
    alert(msg);
  },
  /** 确认提示
   *  @param {string} title 提示标题
   *  @param {string} msg 提示内容
   */
  alert(titles, msg, type) {
    Vue.prototype.$message({
      showClose: true,
      message: msg,
      type: type,
      duration: 3000
    });
  },

  loadings(n) {
    Vue.prototype.$loading({
      lock: true,
      text: "",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.4)",
      target: document.querySelector("body")
    });
    if (n == 2) {
      var loading = Vue.prototype.$loading({});
      loading.close();
    }
  },
  /** 检查(对象|数组)对应(键|下标)内容为空提示
   *  @param {object,Array} obj 对象|数组
   *  @param {object} key 键|下标
   *  @param {string} msg 提示内容
   */
  validateNull(obj, key, msg) {
    if (key.indexOf(Object.keys(obj)) != -1) {
      this.toast(msg ? msg : key + "为空");
      return false;
    } else {
      if (!obj[key]) {
        this.toast(msg ? msg : key + "为空");
        return false;
      }
    }
    return true;
  },
  /** 去除(对象|数组)中为空(null、'null'、undefined，空字符串除外)的字段和下标
   *  @param {object,Array} value 对象|数组
   */
  filterNull(value) {
    if (typeof value == "object") {
      for (let k in value) {
        if (value[k] == null || value[k] == "null" || value[k] == undefined) {
          if (value.length > 0) {
            value.splice(k, 1);
          } else {
            delete value[k];
          }
        }
      }
    }
    return value;
  },
  /** 去除字符串的左右空格
   *  @param {string} value 字符串
   */
  trim(value) {
    if (typeof value === "string") return value.replace(/(^\s*)|(\s*$)/g, "");
    return value;
  },
  /** 数组内容过滤
   *  @param {string} text 过滤包含内容
   *  @param {Array} array 待过滤数组
   *  @param {function} filter 过滤方法
   */
  nativeSearch(text, array, filter) {
    let matches = {};
    let promise = new Promise(resolve => {
      if (!filter) {
        matches = array.filter(function(datas) {
          if (datas.BRXM.indexOf(text) !== -1) return true;
        });
      } else {
        matches = array.filter(filter);
      }
      resolve(matches);
    }).catch(() => {});

    return promise;
  },
  // 格式化时间 时分秒分开（用）
  timestampToTime1(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + " ";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "/";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/";
    //let H =(date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return H + " " + D + M + Y;
  },
  // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
  timestampToTime(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + " | ";
    let M = date.toString().split(" ")[1] + " ";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 < 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    } else if (H - 12 == 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        "PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D + M + Y + H;
  },
  // 格式化时间 返回年月（用月份为英文）
  timestampToYear(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "";
    let M = date.toString().split(" ")[1] + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return M + Y;
  },

  // 格式化时间 返回月日（用月份为英文）
  timestampToMon(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let M = date.toString().split(" ")[1] + " ";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D + M;
  },
  // 格式化时间  传入时间戳，返回小时（用）
  timestampToTimeHour(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    return H;
  },
  // 格式化时间  传入时间戳，返回年月日/am(用)
  timestampToTimes(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "";
    let M = date.toString().split(" ")[1] + " ";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D + M + Y;
  },
  // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
  timestampToTime2(timestamp) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear();
    let M = date.toString().split(" ")[1] + " ";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    // let m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
    return D + M + Y;
  },
  // 格式化时间  传入时间戳，返回年月日/am（用月份为英文）
  timestampToTime3(timestamp) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear() + " ";
    let M = date.toString().split(" ")[1] + " ";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    if (H - 12 <= 0) {
      H =
        H +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " AM";
    } else if (H - 12 > 0 && H - 24 < 0) {
      H =
        H - 12 < 10
          ? "0" +
            (H - 12) +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM"
          : H -
            12 +
            ":" +
            (date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes()) +
            " PM";
    } else if (H - 24 == 0) {
      H =
        "00" +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        " PM";
    }
    return D + M + Y + H;
  },
  //获取当前时间
  getNowDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    // let month=date.toString().split(' ')[1]
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  dianTime(timestamp) {
    let date = new Date(Number(timestamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "  ";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + ".";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + ".";
    return D + M + Y;
  },
  //获取当前月份
  getNowmonth() {
    let date = new Date();
    let seperator1 = "/";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    let currentdate = year + seperator1 + month;
    return currentdate;
  },
  //获取月份最后一天和第一天
  getmonthlastday(val) {
    let endDate = new Date(val);
    let month = endDate.getMonth();
    let nextMonth = ++month;
    let nextMonthFirstDay = new Date(endDate.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let d = new Date(nextMonthFirstDay - oneDay);
    let datetime =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
      "-" +
      d.getDate();
    let datetimes =
      d.getFullYear() +
      "-" +
      (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) +
      "-" +
      "01";
    let obi = {
      last: datetime,
      first: datetimes
    };
    return obi;
  },
  //获取昨天日期
  getyestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
    let date = new Date(day2); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  //获取7天前日期
  get7yestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 7);
    let date = new Date(day2); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  //获取30天前日期
  get30yestoday() {
    var day1 = new Date();
    let day2 = day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 30);
    let date = new Date(day2); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  getWeek() {
    var date = new Date();
    var today = date.getDay();
    var stepSunDay = -today + 1;
    if (today == 0) {
      stepSunDay = -7;
    }
    var stepMonday = 7 - today;
    var time = date.getTime();
    var monday = new Date(time + stepSunDay * 24 * 3600 * 1000);
    var sunday = new Date(time + stepMonday * 24 * 3600 * 1000);

    function transferDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      var dateString = year + "/" + month + "/" + day;
      return dateString;
    }

    //本周一的日期 （起始日期）
    var startDate = transferDate(monday);
    // 日期变换      //本周日的日期 （结束日期）
    var endDate = transferDate(sunday); // 日期变换
    return startDate, endDate;
  },
  //传入本地时间获得标准时间
  localtime(time, n) {
    var date = new Date(time);
    //var times=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    if (n == 0) {
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    }
    return Y + M + D;
  },
  localTIMES() {
    var date = new Date();
    var D = date.getHours();
    var m = date.getMinutes();
    return D + ":" + m;
  },
  getPrice(val) {
    //let check = (Math.ceil(Number(val)) == Number(val)?Number(val)+'.00':Number(val))
    let check = val ? val : "";
    let pos_decimal = String(check).split(".");
    let check_ = pos_decimal[1] ? pos_decimal[1].length : undefined;
    let check_2 = pos_decimal[0] ? pos_decimal[0] : "0";
    let backtime = "";
    if (check_ == undefined) {
      backtime = (check_2 + ".00").trim();
    } else if (check_ == 1) {
      backtime = pos_decimal.join(".") + "0";
    } else if (check_ == 2) {
      backtime = pos_decimal.join(".");
    } else {
      let arr = pos_decimal[1].split("");
      backtime = check_2 + "." + arr[0] + arr[1];
    }
    return String(backtime);
  },
  getTmeing(val) {
    var timestamp2 = Date.parse(new Date(val));
    return timestamp2;
  },
  addERROR(val) {
    let errs = "";
    if (val) {
      if (val.length == 9) {
        errs = "0" + val;
      } else {
        errs = val;
      }
    } else {
      errs = val;
    }
    return errs;
  },
  getPhone(number) {
    //格式化手机号码
    if (number) {
      let arr = number.split("");
      let str1 = "";
      let str2 = "";
      let str3 = "";
      arr.forEach((item, i) => {
        if (i == 0 && item !== 0) {
          str1 = `+61${item}`;
        }
        if (i > 0 && i < 5) {
          str2 += item;
        }
        if (i > 4 && i < 9) {
          str3 += item;
        }
      });
      return str1 + " " + str2 + " " + str3;
    }
  },
  getABN(key) {
    let num = key.replace(/\s+/g, "");
    if (num && num.length > 2) {
      num = num.split("");
      let num1 = num.splice(0, 2).join("");
      let result = [];
      let result2 = [];
      for (var i = 0; i < num.length; i += 3) {
        result.push(num.slice(i, i + 3));
      }
      result.forEach(fruit => {
        result2.push(fruit.join(""));
      });
      num = num1 + " " + result2.join(" ");
    }
    return num;
  },
  removeRepeatArray(arr) {
    return arr.filter(function(item, index, self) {
      return self.indexOf(item) === index;
    });
  },
  isContained(a, b) {
    if (!(a instanceof Array) || !(b instanceof Array)) return false;
    if (a.length < b.length) return false;
    var aStr = a.toString();
    for (var i = 0, len = b.length; i < len; i++) {
      if (aStr.indexOf(b[i]) == -1) return false;
    }
    return true;
  },
  formatReserveDate(date) {
    if (!date) {
      return "";
    }
    date = new Date(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    m = m < 10 ? "0" + m : m;
    return d + "/" + m + "/" + y;
  },
  formatdate(date) {
    if (!date) {
      return "select time";
    }
    date = new Date(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    if (m == 1) {
      m = "Jan";
    } else if (m == 2) {
      m = "Feb";
    } else if (m == 3) {
      m = "Mar";
    } else if (m == 4) {
      m = "Apr";
    } else if (m == 5) {
      m = "May";
    } else if (m == 6) {
      m = "June";
    } else if (m == 7) {
      m = "July";
    } else if (m == 8) {
      m = "Aug";
    } else if (m == 9) {
      m = "Sept";
    } else if (m == 10) {
      m = "Oct";
    } else if (m == 11) {
      m = "Nov";
    } else {
      m = "Dec";
    }
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    return d + " " + m + " " + y;
  },
  formatdateminute(date) {
    if (!date) {
      return "select time";
    }
    date = new Date(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    if (m == 1) {
      m = "Jan";
    } else if (m == 2) {
      m = "Feb";
    } else if (m == 3) {
      m = "Mar";
    } else if (m == 4) {
      m = "Apr";
    } else if (m == 5) {
      m = "May";
    } else if (m == 6) {
      m = "June";
    } else if (m == 7) {
      m = "July";
    } else if (m == 8) {
      m = "Aug";
    } else if (m == 9) {
      m = "Sept";
    } else if (m == 10) {
      m = "Oct";
    } else if (m == 11) {
      m = "Nov";
    } else {
      m = "Dec";
    }
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;

    var h = date.getHours();
    var minute = date.getMinutes();
    if (h < 13) {
      h = h < 10 ? "0" + h + ":" + minute + " AM" : h + ":" + minute + " AM";
    } else {
      h = h - 12;
      h = h < 10 ? "0" + h + ":" + minute + " PM" : h + ":" + minute + " PM";
    }

    return d + " " + m + " " + y + " | " + h;
  },
  formatNumber(number) {
    let all = number.split("");
    let result =
      "+61" +
      all[0] +
      " " +
      all[1] +
      all[2] +
      all[3] +
      all[4] +
      " " +
      all.slice(5).join("");
    return result;
  },
  formatFloat(number) {
    number = JSON.stringify(number);
    let result;
    if (number.indexOf(".") == -1) {
      result = number + ".00";
    } else {
      let arr = number.split(".");
      result = number;
      if (arr[1].length == 1) {
        result = result + "0";
      }
    }
    return result;
  },
  formatSplit(s, type) {
    if (s == 0) {
      return "0";
    }
    if (!s) {
      return null;
    }
    if (s == null || s == "") {
      return "";
    }
    if (JSON.stringify(s).indexOf(".") === -1) {
      type = 0;
    }
    s =
      s < 0 && type === 0
        ? s.toString().replace(/^(\d*)$/, "$1.") + "."
        : s.toString().replace(/^(\d*)$/, "$1.");
    s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    s = s.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(s)) s = s.replace(re, "$1,$2");
    s = s.replace(/,(\d\d)$/, ".$1");
    if (type == 0) {
      // 不带小数位(默认是有小数位)
      var a = s.split(".");
      if (a[1] == "00") {
        s = a[0];
      }
    }
    return s;
  },
  formatTimestamp(timestamp) {
    var time = new Date(timestamp * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var result = "";
    if (m == 1) {
      result = `${d} Jan ${y}`;
    } else if (m == 2) {
      result = `${d} Feb ${y}`;
    } else if (m == 3) {
      result = `${d} Mar ${y}`;
    } else if (m == 4) {
      result = `${d} Apr ${y}`;
    } else if (m == 5) {
      result = `${d} May ${y}`;
    } else if (m == 6) {
      result = `${d} Jun ${y}`;
    } else if (m == 7) {
      result = `${d} Jul ${y}`;
    } else if (m == 8) {
      result = `${d} Aug ${y}`;
    } else if (m == 9) {
      result = `${d} Sept ${y}`;
    } else if (m == 10) {
      result = `${d} Oct ${y}`;
    } else if (m == 11) {
      result = `${d} Nov ${y}`;
    } else if (m == 12) {
      result = `${d} Dec ${y}`;
    }
    return result;
  },
  formatTimestampLL(timestamp) {
    var time = new Date(timestamp * 1000);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var result = "";
    var hz = "";
    if (d == 1) {
      hz = "st"; //
    } else if (d == 2) {
      hz = "nd"; //
    } else if (d == 3) {
      hz = "rd"; //
    } else if (d > 3 && d < 21) {
      hz = "th"; //
    } else if (d == 21) {
      hz = "st"; //
    } else if (d == 22) {
      hz = "nd"; //
    } else if (d == 23) {
      hz = "rd"; //
    } else if (d > 23 && d < 32) {
      hz = "th"; //
    }
    if (m == 1) {
      result = `${d}${hz} Jan ${y}`;
    } else if (m == 2) {
      result = `${d}${hz} Feb ${y}`;
    } else if (m == 3) {
      result = `${d}${hz} Mar ${y}`;
    } else if (m == 4) {
      result = `${d}${hz} Apr ${y}`;
    } else if (m == 5) {
      result = `${d}${hz} May ${y}`;
    } else if (m == 6) {
      result = `${d}${hz} Jun ${y}`;
    } else if (m == 7) {
      result = `${d}${hz} Jul ${y}`;
    } else if (m == 8) {
      result = `${d}${hz} Aug ${y}`;
    } else if (m == 9) {
      result = `${d}${hz} Sept ${y}`;
    } else if (m == 10) {
      result = `${d}${hz} Oct ${y}`;
    } else if (m == 11) {
      result = `${d}${hz} Nov ${y}`;
    } else if (m == 12) {
      result = `${d}${hz} Dec ${y}`;
    }
    return result;
  },
  formatTelNumber(number) {
    if (number.length == 8) {
      number = number.split("");
      number.splice(4, 0, " ");
      number = number.join("");
    } else if (number.length == 9) {
      number = number.split("");
      number.splice(3, 0, " ");
      number.splice(7, 0, " ");
      number = number.join("");
    } else if (number.length == 10) {
      number = number.split("");
      number.splice(4, 0, " ");
      number.splice(8, 0, " ");
      number = number.join("");
    }
    return number;
  },
  formatAbn(number) {
    if (number.length == 9) {
      number = number.split("");
      number.splice(3, 0, " ");
      number.splice(7, 0, " ");
      number = number.join("");
      return number;
    } else if (number.length == 11) {
      number = number.split("");
      number.splice(2, 0, " ");
      number.splice(6, 0, " ");
      number.splice(10, 0, " ");
      number = number.join("");
      return number;
    } else {
      return "format error";
    }
  },
  // 取整，再分成数组
  formatMaxLst(number) {
    number = parseInt(number);
    if (number < 600) {
      return 600;
    } else {
      const qm = parseInt(
        JSON.stringify(number).slice(0, JSON.stringify(number).length - 2)
      );
      const rqm = qm + 1;
      const yu = rqm % 6;
      const result = (rqm + (6 - yu)) * 100;
      return result;
    }
  },
  // 取整，再分成数组
  formatMaxLst2(number) {
    number = parseInt(number);
    if (number < 700) {
      return 700;
    } else {
      console.log(number);
      const qm = parseInt(
        JSON.stringify(number).slice(0, JSON.stringify(number).length - 2)
      );
      const rqm = qm + 1;
      const yu = rqm % 7;
      const result = (rqm + (7 - yu)) * 100;
      return result;
    }
  },
  // Setting the switch color
  toggleSwitchColor() {
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  }
};



// WEBPACK FOOTER //
// ./src/utils/index.js